module.exports = __webpack_public_path__ + "img/about.involvement.project.asset.6abc241a.jpg";